import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IEnvironment } from '../models/environment';


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {


  environment: IEnvironment;
  public dynatraceSource: string;

  // public environment;
  constructor() {
    const browserWindow = (window || {}) as any;
    if ((<any>window).__env) {
      this.environment = (<any>window).__env;
      // SafeLogger.log("External environment config used");
    } else if (!environment.production) {  //This should only be pulled in during 'ng test'.
      this.environment = environment as any;
      // SafeLogger.warn(">>>>> Testing environment config used <<<<<");
    } else { // use local default environment
      throw new Error('Missing env script!');
    }
    this.dynatraceSource = browserWindow.__env?.dynatraceSource;
  }
}
